import moment from 'moment';

export var MONTHLY_PAYMENT_FILTERS_KEY = 'financeiro.mensalidades';

// Same period/status/filter_by/customer defaults as the redux slice
// (MonthlyPayment/reducer.js), plus the page's local filters.
export var getDefaultMonthlyPaymentFilters = function() {
  return {
    from: moment().format('YYYY-MM-01'),
    to: moment().endOf('month').format('YYYY-MM-DD'),
    status: 'all',
    filter_by: 'due_at',
    customer_id: 'all',
    search: '',
    onlyNotReajusted: false,
  };
};

// Applied filters -> loadPayments params (also what ends up in monthlyPayment.filter).
export var toMonthlyPaymentsRequest = function(filters) {
  return {
    from: filters.from,
    to: filters.to,
    status: filters.status || 'all',
    filter_by: filters.filter_by || 'due_at',
    customer_id: (filters.customer_id !== null && filters.customer_id !== undefined) ? filters.customer_id : 'all',
  };
};

// True when from/to cover exactly one calendar month (1st to last day).
export var isSingleWholeMonth = function(from, to) {
  if (!from || !to) return false;
  var start = moment(from, 'YYYY-MM-DD');
  var end = moment(to, 'YYYY-MM-DD');
  return start.isSame(end, 'month') &&
    start.date() === 1 &&
    end.date() === end.daysInMonth();
};

export var getPeriodLabel = function(from, to) {
  if (isSingleWholeMonth(from, to)) {
    return 'Mês: ' + moment(from, 'YYYY-MM-DD').format('MMM/YYYY');
  }
  return moment(from, 'YYYY-MM-DD').format('DD/MM/YY') + ' - ' + moment(to, 'YYYY-MM-DD').format('DD/MM/YY');
};

export var isPeriodDefault = function(filters, defaults) {
  return filters.from === defaults.from && filters.to === defaults.to;
};

// Badge count: only what differs from the defaults (period counts as one).
export var countActiveFilters = function(filters, defaults) {
  return (isPeriodDefault(filters, defaults) ? 0 : 1) +
    (filters.filter_by !== defaults.filter_by ? 1 : 0) +
    (filters.status !== defaults.status ? 1 : 0) +
    (filters.customer_id !== defaults.customer_id ? 1 : 0) +
    (filters.onlyNotReajusted ? 1 : 0) +
    (filters.search ? 1 : 0);
};
